// extracted by mini-css-extract-plugin
export default {"vpnType":"VpnTypes_vpnType__pm-by","isOnline":"VpnTypes_isOnline__XVimK"};